import PropTypes from "prop-types";
import React from "react";
import { useSimulation } from "../contexts/Simulation";
import ConditionalTooltip from "./ConditionalTooltip";

// FIXME
// Unused because it adds MUI HTML in the HTML Viewer and
// HTML within the component will not show up in the HTML VIEWER.
function SimulationTooltip(props) {
  const { key, title, children } = props;

  // Contexts
  const { showTooltips } = useSimulation();

  // Render
  if (showTooltips) {
    return (
      <ConditionalTooltip key={key} title={title} condition>
        {children}
      </ConditionalTooltip>
    );
  }

  return children;
}

SimulationTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  key: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

export default SimulationTooltip;
